import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app";

// Define a loading for the slice state
interface loadingState {
  indexes: boolean;
  conversations: boolean;
  prompts: boolean;
  db: boolean;
  fullscreen: boolean;
  userFormats: boolean;
  shared_docs: boolean;
}

// Define the initial state using that loading
const initialState: loadingState = {
  indexes: false,
  conversations: false,
  prompts: false,
  db: false,
  fullscreen: false,
  userFormats: false,
  shared_docs: false,
};

export const loadingSlice = createSlice({
  name: "loading",
  // `createSlice` will infer the state loading from the `initialState` argument
  initialState,
  reducers: {
    loadingforindexes: (state, action) => {
      state.indexes = action.payload;
    },
    loadingforconversation: (state, action) => {
      state.conversations = action.payload;
    },
    loadingforprompts: (state, action) => {
      state.conversations = action.payload;
    },
    loadingfordatabase: (state, action) => {
      state.db = action.payload;
    },
    loadingforfullscreen: (state, action) => {
      state.fullscreen = action.payload;
    },
    loadingforUserprompts: (state, action) => {
      state.userFormats = action.payload;
    },
    loadingforSharedDocs: (state, action) => {
      state.userFormats = action.payload;
    },
  },
});

export const {
  loadingforconversation,
  loadingforindexes,
  loadingforprompts,
  loadingfordatabase,
  loadingforfullscreen,
  loadingforUserprompts,
  loadingforSharedDocs,
} = loadingSlice.actions;

// Other code such as selectors can use the imported `RootState` loading

export const getloadingforconversations = (state: RootState) =>
  state.loading.conversations;
export const getloadingforindexes = (state: RootState) => state.loading.indexes;
export const getloadingforprompts = (state: RootState) => state.loading.prompts;
export const getloadingfordb = (state: RootState) => state.loading.db;
export const getloadingforfullscreen = (state: RootState) =>
  state.loading.fullscreen;
export const getloadingforuserformats = (state: RootState) =>
  state.loading.userFormats;
export const getloadingforsharedDocs = (state: RootState) =>
  state.loading.shared_docs;

export default loadingSlice.reducer;
